import "./Description.scss";

import React from "react";
import { Link } from "react-router";
import { TrackingTags } from "shared/src/tracking/Tracking";

type Props = {
    description: string | undefined;
    pdpLink: string | null;
    eventId: string;
    bettyBundleId: string | undefined;
    optionalTrackingTags?: Partial<TrackingTags>;
    onArticleOpen: (
        clickedElement: string,
        eventId: string,
        bettyBundleId: string | null | undefined,
        optionalTrackingTags?: Partial<TrackingTags>
    ) => void;
};

export default function Description({
    description,
    pdpLink,
    eventId,
    bettyBundleId,
    optionalTrackingTags,
    onArticleOpen
}: Props) {
    const pureDescription = (
        <div className="title-wrapper">
            <h4>{description}</h4>
        </div>
    );

    if (!pdpLink) return pureDescription;

    return (
        <Link
            className="title"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore  -- Note: The description is not a real property of Links, but something we just pass on anyways
            description={description}
            to={pdpLink}
            onClick={() => onArticleOpen("title", eventId, bettyBundleId, optionalTrackingTags)}>
            {pureDescription}
        </Link>
    );
}
